module.exports = __webpack_public_path__ + "img/menu-outline.caa1ecd5.svg";